import Vue from 'vue'
import VueRouter from 'vue-router'
// import { Message } from 'element-ui';
import {
    checkLoginExpiry,
    clearAuth
} from '@/untils/checkLoginOut'
// import Index from '../views/index/FormalClinic.vue'
// layout(布局)
//导入需要的组件
import Login from "../views/login/Login.vue"
import Layout from "../views/layout/Layout.vue"

import system from "../views/system/system.vue"

// 解决路由重复报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)
// Vue.use(Message)

const routes = [
    //登录
    {
        path: "/login",
        name: 'login',
        component: Login,
    },
    // index
    {
        path: "/",
        component: Layout,
        redirect: "/home", //重定向
        name: 'home',
        permission: 'home',
        children: [{
            path: "/home",
            meta: {
                title: '',
                path: "/"
            },
            component: () => import("../views/index/index.vue")
        }]
    },

    //系统管理
    {
        path: "/system",
        permission: 'system',
        component: Layout,
        redirect: "/user/index",
        meta: {
            path: "/user/index",
            title: "系统管理"
        },
        children: [
            // 诊所列表
            {
                path: "/formalClinic",
                permission: 'user',
                meta: {
                    title: '正式诊所',
                    path: "/formalClinic.vue"
                },
                component: () => import("@/views/system/formalClinic/FormalClinic.vue"),
            },
            {
                path: "/trialClinic",
                permission: 'user',
                meta: {
                    title: '试用诊所',
                    path: "/trialClinic"
                },
                component: () => import("@/views/system/trialClinic/TrialClinic.vue"),
            },

            {
                path: "/systemParameter",
                permission: 'user',
                meta: {
                    title: '系统参数',
                    path: "/systemParameter"
                },
                component: () => import("@/views/systemParameter/systemParameter.vue"),
            },
            {
                path: "/distributorList",
                permission: 'user',
                meta: {
                    title: '经销商列表',
                    path: "/distributorList"
                },
                component: () => import("@/views/distributor/distributorList.vue"),
            },
            {
                path: "/operationAnalysis",
                permission: 'user',
                meta: {
                    title: '经营分析',
                    path: "/operationAnalysis"
                },
                component: () => import("@/views/operationAnalysis/OperationAnalysis.vue"),
            },
            {
                path: '/distributorList/channelChangeAudit',
                name: 'ChannelChangeAudit',
                component: () => import('@/views/distributor/ChannelChangeAudit.vue'),
                meta: {title: '经销商审批管理', icon: 'el-icon-s-check'}
            },
            {
                path: "/roleIndex",
                permission: 'user',
                meta: {
                    title: '角色列表',
                    path: "/roleIndex"
                },
                component: () => import("@/views/system/role/index.vue"),
            },
            {
                path: "/menu",
                permission: 'menu',
                meta: {
                    title: '前台菜单列表',
                    path: "/menu"
                },
                component: () => import("@/views/menu/menu.vue"),
            },
            {
                path: "/system/menu",
                permission: 'systemMenu',
                meta: {
                    title: '后台菜单管理',
                    path: "/system/menu"
                },
                component: () => import("@/views/system/menu/index.vue"),
            },
            {
                path: "/backgroundRole",
                permission: 'backgroundRole',
                meta: {
                    title: '后台角色管理',
                    path: "/backgroundRole"
                },
                component: () => import("@/views/system/backgroundRole/backgroundRole.vue"),
            },
            {
                path: "/userIndex",
                permission: 'userIndex',
                meta: {
                    title: '后台用户管理',
                    path: "/userIndex"
                },
                component: () => import("@/views/system/user/index.vue"),
            },
            {
                path: "/foregroundUser/foregroundUser",
                permission: 'foregroundUser',
                meta: {
                    title: '前台用户管理',
                    path: "/foregroundUser/foregroundUser"
                },
                component: () => import("@/views/ForegroundUser/ForegroundUser.vue"),
            },
            {
                path: "/backgroudDept",
                permission: 'backgroudDept',
                meta: {
                    title: '后台部门管理',
                    path: "/backgroudDept"
                },
                component: () => import("@/views/system/backgroundDept/backgroudDept.vue"),
            },
            {
                path: "/dict",
                permission: 'dict',
                meta: {
                    title: '后台字典管理',
                    path: "/dict"
                },
                component: () => import("@/views/system/dict/dict.vue"),
            },

        ]
    },

]


const router = new VueRouter({
    routes
})


// 添加全局后置钩子
// router.afterEach((to, from) => {
//   // 设置超时判断逻辑
//   setTimeout(() => {
//     // 判断当前路由是否与to相同
//     if (router.currentRoute.path === to.path) {
//       // 执行超时后的操作，例如显示一个错误提示或者进行页面跳转
//       // console.log('登录超时');
// 	  this.$message('长时间未操作，请重新登录！', '系统提示', {
// 		confirmButtonText: '确定',
// 		callback: action => {
// 		  router.push('/login'); // 可以选择跳转到一个超时错误页面
// 		}
// 	  });

//     }
//   }, 5000); // 设置超时时间为5秒
// });

//水印哈希码
const generateHash = (text) => {
    let hash = 0
    for (let i = 0; i < text.length; i++) {
        hash = ((hash << 5) - hash) + text.charCodeAt(i)
        hash |= 0 // 转换为32位整数
    }
    return hash.toString()
}
// 修改后的水印验证函数，返回验证结果
const checkWatermark = () => {
    try {
        const part1 = sessionStorage.getItem('w_part1')
        const part2 = localStorage.getItem('w_part2')
        const part3 = sessionStorage.getItem('w_part3')
        const storedHash = localStorage.getItem('w_hash')

        if (part1 && part2 && part3 && storedHash) {
            const watermarkText = `${part1}-${part2}-${part3}`
            if (generateHash(watermarkText) === storedHash) {
                watermark.set(watermarkText)
                return true // 验证通过
            }
        }
        watermark.set('水印已被篡改')
        return false // 验证失败
    } catch (e) {
        console.error('水印验证失败:', e)
        watermark.set('水印已被篡改')
        return false // 验证失败
    }
}
const clearWatermarkData = () => {
    try {
        // 清除所有水印存储
        sessionStorage.removeItem('w_part1');
        localStorage.removeItem('w_part2');
        sessionStorage.removeItem('w_part3');
        localStorage.removeItem('w_hash');

        // 清除水印显示
        if (watermark && typeof watermark.clear === 'function') {
            watermark.clear();
        } else {
            // 备用清除方法
            const watermarkElements = document.querySelectorAll('[id^="watermark-"]');
            watermarkElements.forEach(el => el.remove());
        }
    } catch (e) {
        console.error('清理水印数据失败:', e);
    }
};

// 全局前置守卫
router.beforeEach((to, from, next) => {
    //from
    //to
    //next 放行
    // 检查是否登录过期
    if (checkLoginExpiry()) {
        clearAuth()
        next('/login')
        Vue.prototype.$message.error('登录已超时，请重新登录')
        return
    }
    //判断本地存储是否有token，如果有就直接放行，否则返回登录页面。
    let isLogin = localStorage.getItem("token") ? true : false;
    if (isLogin) {
        next()
    } else {
        if (to.path == '/login') {
            next()
        } else {
            next(`/login?redirect=${to.path}`)
        }

    }

})

//暴露路由对象
export default router